module.exports = __webpack_public_path__ + "img/FinancialDigitalize.5aaae346.svg";